import MeetupList from "../components/layout/meetups/MeetupList";
import { useState, useEffect } from "react";
import ClipLoader from "react-spinners/RingLoader";
import {
	collection,
	getDocs,
	limit,
	startAfter,
	query,
	orderBy,
	getCountFromServer,
	getDoc,
	doc,
	where,
} from "firebase/firestore";
import { db } from "../index";
import classes from "./AllMeetups.module.css";
import Alert from "react-bootstrap/Alert"

function AllMeetupsPage() {
	const [isLoading, setIsLoading] = useState(true);
	const [loadedMeetups, setLoadedMeetups] = useState([]);
	const [totalData, setTotalData] = useState(0);
	const [error, setError] = useState(false);
	const [fireError, setFireError] = useState(false);
	const [search, setSearch] = useState("");
	const [searchResults, setSearchResults] = useState(false);
	const loaded_search_function_data = [];
	useEffect(() => {
		setIsLoading(true);
		const docSnap = async () => {
			const data = [];
			try {
				if (searchResults === false) {
					// get number of data available in database...
					const query_data = query(
						collection(db, "meetups"),
						orderBy("timestamp", "desc")
					);
					const get_count = await getCountFromServer(query_data);
					const total_data = get_count.data().count;
					console.log(("Total Data", total_data));

					// this is for pagination...
					const original_page = query(
						collection(db, "meetups"),
						orderBy("timestamp", "desc"),
						limit(16)
					);
					const dataSnap = await getDocs(original_page);
					dataSnap.forEach((doc) => {
						//console.log(doc.id, " => ", doc.data());
						data.push({
							id: doc.id,
							...doc.data(),
						});
					});
					setIsLoading(false);
					setLoadedMeetups(data);
					setTotalData(total_data);
					console.log(data);
				}
			} catch (error) {
				setFireError(true);
				setIsLoading(false);
				console.log(error);
			} finally {
				setIsLoading(false);
			}
		};
		docSnap();
	}, [searchResults]);

	const load_more = async (last_item_id) => {
		try {
			setIsLoading(true);
			const init_last_data = doc(db, "meetups", last_item_id);
			const get_init_last_data = await getDoc(init_last_data);
			const new_loaded_data = [];
			const next_data = query(
				collection(db, "meetups"),
				orderBy("timestamp", "desc"),
				startAfter(get_init_last_data),
				limit(15)
			);

			const new_data = await getDocs(next_data);
			new_data.forEach((doc) => {
				new_loaded_data.push({
					id: doc.id,
					...doc.data(),
				});
			});
			const site_data = loadedMeetups.concat(new_loaded_data);
			console.log(site_data);
			setLoadedMeetups(site_data);
		} catch (error) {
			console.error(error);
			setFireError(true);
		} finally {
			setIsLoading(false);
		}
	};

	const search_func = async (searched_data) => {
		setSearchResults(true);
		setIsLoading(true);

		if (searched_data !== "") {
			try {
				const data_query = query(
					collection(db, "meetups"),
					orderBy("addressLower"),
					where("addressLower", ">=", searched_data.toLowerCase()),
					where(
						"addressLower",
						"<=",
						searched_data.toLowerCase() + "\uf8ff"
					) // Append "\uf8ff" to create an upper bound
				);
				const full_data = await getDocs(data_query);
				full_data.forEach((doc) => {
					loaded_search_function_data.push({
						id: doc.id,
						...doc.data(),
					});
				});
				if (loaded_search_function_data.length === 0) {
					setError(true);
				} else {
					setLoadedMeetups(loaded_search_function_data);
					setIsLoading(false);
				}
				console.log(loaded_search_function_data);
			} catch (error) {
				setError(true);
				console.log(error);
			}
		} else {
			setError(true);
		}
	};

	const handleRefresh = () => {
		setSearchResults(false);
		setSearch("");
		setError(false);
	};

	const last_item = loadedMeetups[loadedMeetups.length - 1];

	return (
		<div>
			<section>
				<h1
					style={{
						fontFamily: "monospace",
						color: "#1E90FF",
						fontWeight: "bold",
						marginTop: "1rem",
					}}
				>
					Wanderlust
				</h1>
				{error && loaded_search_function_data.length === 0 && (
					<Alert style={{ textAlign: "center" }}>
						Sorry, we don't have {search} in our database...
					</Alert>
				)}
				{fireError && (
					<Alert style={{ textAlign: "center" }}>
						Sorry, there was an error loading the data...
					</Alert>
				)}
				{!error && !fireError && (
					<>
						<div
							style={{
								display: "flex",
								flexWrap: "wrap",
								padding: "1.5rem",
								justifyContent: "center",
								alignItems: "center",
								marginTop: "2%",
								width: "auto",
							}}
						>
							<input
								type="text"
								value={search}
								placeholder="search"
								onChange={(e) => setSearch(e.target.value)}
								className={classes.input}
							/>
							<button
								onClick={(e) => search_func(search)}
								className={classes.searchbutton}
							>
								Search
							</button>
						</div>
						<div></div>
						<MeetupList meetups={loadedMeetups} />
						{isLoading && (
							<section className={classes.loader}>
								<ClipLoader
									color={"#007FFF"}
									loading={isLoading}
									size={50}
									aria-label="Loading Spinner"
									data-testid="loader"
								/>
							</section>
						)}
					</>
				)}
				{!isLoading &&
					loadedMeetups.length < totalData &&
					!searchResults && (
						<div
							style={{
								display: "flex",
								alignContent: "center",
								justifyContent: "center",
								marginTop: "3.5rem",
							}}
						>
							<button
								style={{ padding: "2rem", width: "auto" }}
								className={classes.updatebutton}
								onClick={(e) => load_more(last_item.id)}
							>
								Load More...
							</button>
						</div>
					)}
				{searchResults && (
					<div
						style={{
							display: "flex",
							alignContent: "center",
							justifyContent: "center",
							marginTop: "3.5rem",
						}}
					>
						<button
							className={classes.updatebutton}
							style={{ padding: "2rem", width: "auto" }}
							onClick={handleRefresh}
						>
							Back
						</button>
					</div>
				)}
			</section>
		</div>
	);
}

export default AllMeetupsPage;
